import React, { Component } from "react"

class LandingOfferSection extends Component {

  render() {
    const layout = this.props.content
    return (
      layout.field_description_wysiwyg !== null ? (
        <div className="container">
          <div className="uk-flex uk-flex-center uk-text-uppercase">
            {layout.field_title ? (
              <h4 className="title"><strong>{layout.field_title}</strong></h4>
            ) : (
              null
            )}
          </div>
          <div data-uk-grid>
            <div className="uk-width-1-3@m left-column uk-flex uk-flex-column">
              <div className="uk-flex uk-flex-column uk-width-4-5" dangerouslySetInnerHTML={{ __html: layout.field_description_wysiwyg.value }} />
            </div>

            <div className="uk-divider-vertical uk-width-expand@m uk-flex uk-flex-middle uk-flex-column">
              <div className="content-wrp-right-column uk-flex uk-text-center uk-flex-column" dangerouslySetInnerHTML={{ __html: layout.field_right_content?.value }} />
              {layout.relationships.field_list_items ? (
                <div className="uk-child-width-1-2@m uk-width-1-1" data-uk-grid>
                  {layout.relationships.field_list_items && layout.relationships.field_list_items.map( (item,key) => (
                    <div className="uk-text-center" key={`landing-offer-${key}`}>
                      <div className="image-wrp">
                        <img className="uk-object-contain" src={item.relationships?.field_icon?.uri?.url} alt={item.field_title} />
                      </div>
                      <div className="card-text-wrp uk-flex uk-flex-column uk-flex-middle">
                        <h3>{item.field_title}</h3>
                        <p>{item.field_description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                null
              )}

            </div>
          </div>
        </div>
      ) : (
        null
      )
    )
  }
}

export default LandingOfferSection
